export const FORMAT_BUILDER_EN = {
  // FormatBuilder.vue
  formatBuilder: 'Format Builder',
  fbSaving: 'Saving...',
  fbSave: 'Save',
  fbPreview: 'Preview',
  fbEditTemplate: 'Edit Template',
  fbShowHtml: 'Show HTML',
  fbLoadingCustomization: 'Loading customization...',
  fbNoFormatSelected: 'No format selected',
  fbNoFormatSelectedHint: 'Select a format from the sidebar or create a new one',
  fbGeneratingTemplate: 'Generating Template',
  fbAiCreating: 'AI is creating "{name}"...',
  fbAdminManagedFormat: 'Admin Managed Format',
  fbAdminManagedDesc:
    'This format is managed by your organisation administrator and cannot be edited here.',
  fbAdminManagedHint: 'Contact your admin if you need changes to this format.',
  fbLegacyFormat: 'Legacy Format',
  fbLegacyFormatDesc:
    'This format uses a legacy structure with custom tags and inline documentation. It cannot be edited in the visual builder.',
  fbLegacyFormatHint: 'To modify this format, edit it directly in the customization settings.',
  fbOpenCustomizationSettings: 'Open Customization Settings',
  fbHtmlOutput: 'HTML Output',
  fbCopied: 'Copied!',
  fbCopy: 'Copy',

  // FormatBuilderCanvas.vue
  fbAddElement: 'Add Element',
  fbHeadings: 'Headings',
  fbText: 'Text',
  fbQuotes: 'Quotes',
  fbListsAndTables: 'Lists & Tables',
  fbOther: 'Other',
  fbHeading1: 'Heading 1',
  fbHeading2: 'Heading 2',
  fbHeading3: 'Heading 3',
  fbHeading4: 'Heading 4',
  fbParagraph: 'Paragraph',
  fbLeadParagraph: 'Lead Paragraph',
  fbByline: 'Byline',
  fbBlockquote: 'Blockquote',
  fbPullQuote: 'Pull Quote',
  fbCitation: 'Citation',
  fbBulletList: 'Bullet List',
  fbNumberedList: 'Numbered List',
  fbTable: 'Table',
  fbCalloutBox: 'Callout Box',
  fbDivider: 'Divider',
  fbLineBreak: 'Line Break',
  fbBlockName: 'Block name',
  fbOptional: 'Optional',
  fbWords: 'words',
  fbInfo: 'Info',
  fbWarning: 'Warning',
  fbSuccess: 'Success',
  fbNote: 'Note',
  fbHeaderRow: 'Header row',
  fbRow: 'Row',
  fbCol: 'Col',

  // FormatBuilderSidebar.vue
  fbBack: 'Back',
  fbCustomization: 'Customization',
  fbFormats: 'Formats',
  fbAdmin: 'Admin',
  fbLegacy: 'Legacy',
  fbNoFormatsYet: 'No formats yet',
  fbSaveAllChanges: 'Save All Changes',
  fbDeleteFormat: 'Delete Format',
  fbDeleteFormatConfirm: 'Are you sure you want to delete "{name}"? This action cannot be undone.',
  fbCancel: 'Cancel',
  fbDelete: 'Delete',

  // FormatBuilderPreview.vue
  fbDetails: 'Details',
  fbAddElementsToPreview: 'Add elements to see the preview',

  // FormatBuilderAIEditor.vue
  fbEditWithAi: 'Edit with AI',
  fbEditWithAiDesc: 'Describe the changes you want to make to the current template.',
  fbEditWithAiPlaceholder:
    'e.g., Add a subtitle section after the headline, make the lead paragraph optional, add a table with 3 columns...',
  fbPressToSend: 'Press',
  fbToSend: 'to send',
  fbEditing: 'Editing...',
  fbApplyChanges: 'Apply Changes',

  // FormatBuilderTagPalette.vue
  fbTemplate: 'Template',

  // FormatCreationDialog.vue
  fbAddNewFormat: 'Add New Format',
  fbAddNewFormatDesc:
    'Enter a name and describe the format. Optionally provide example content to help AI generate a better template.',
  fbFormatName: 'Format name',
  fbFormatNamePlaceholder: 'e.g. News Article',
  fbDescription: 'Description',
  fbDescriptionPlaceholder:
    "Describe the format template (e.g., 'A news article with headline, lead paragraph, 3 body sections, and a conclusion')",
  fbUploadExampleFiles: 'Upload example files',
  fbOptionalLabel: '(optional)',
  fbDropFilesHere: 'Drop files here or click to browse',
  fbFileTypes: 'PDF, DOCX, DOC, TXT',
  fbUploadHint:
    'Upload example articles or documents so the AI can base the template on real content.',
  fbProcessing: 'Processing',
  fbDone: 'Done',
  fbAddExampleUrls: 'Add example URLs',
  fbAdd: 'Add',
  fbUrlHint: 'Add URLs to example articles so the AI can analyze their structure.',
  fbScraping: 'Scraping',
  fbPasteExampleText: 'Paste example text',
  fbPasteExampleTextPlaceholder: 'Paste example article text here...',
  fbPasteExampleTextHint: 'Paste sample text so the AI can understand the content structure.',
  fbGenerateAndAdd: 'Generate & Add',

  // useFormatManagement.ts (toasts)
  fbToastFetchFailed: 'Failed to fetch customization',
  fbToastNameEmpty: 'Format name cannot be empty',
  fbToastNameExists: 'A format with this name already exists',
  fbToastFormatNotFound: 'Format not found',
  fbToastCannotDeleteGenerating: 'Cannot delete a format while it is generating',
  fbToastFormatRemoved: 'Format "{name}" removed',
  fbToastNoCustomization: 'No customization loaded',
  fbToastFormatDeleted: 'Format "{name}" deleted',
  fbToastDeleteFailed: 'Failed to delete format',
  fbToastHtmlEmpty: 'HTML content cannot be empty',
  fbToastInvalidHtml: 'Invalid HTML structure',
  fbToastTagNotAllowed: 'Tag <{tag}> is not allowed',
  fbToastParseFailed: 'Failed to parse HTML',
  fbToastFormatSaved: 'Format "{name}" saved successfully',
  fbToastSaveFailed: 'Failed to save format',
  fbToastInvalidFormats: 'Invalid HTML in formats: {names}',
  fbToastAllSaved: 'All formats saved successfully',
  fbToastSaveAllFailed: 'Failed to save formats'
}

export const FORMAT_BUILDER_DE = {
  // FormatBuilder.vue
  formatBuilder: 'Format Builder',
  fbSaving: 'Speichern...',
  fbSave: 'Speichern',
  fbPreview: 'Vorschau',
  fbEditTemplate: 'Vorlage bearbeiten',
  fbShowHtml: 'HTML anzeigen',
  fbLoadingCustomization: 'Anpassung wird geladen...',
  fbNoFormatSelected: 'Kein Format ausgewählt',
  fbNoFormatSelectedHint: 'Wähle ein Format aus der Seitenleiste oder erstelle ein neues',
  fbGeneratingTemplate: 'Vorlage wird erstellt',
  fbAiCreating: 'KI erstellt „{name}"...',
  fbAdminManagedFormat: 'Admin-verwaltetes Format',
  fbAdminManagedDesc:
    'Dieses Format wird von Ihrem Organisationsadministrator verwaltet und kann hier nicht bearbeitet werden.',
  fbAdminManagedHint:
    'Kontaktieren Sie Ihren Administrator, wenn Sie Änderungen an diesem Format benötigen.',
  fbLegacyFormat: 'Legacy-Format',
  fbLegacyFormatDesc:
    'Dieses Format verwendet eine ältere Struktur mit benutzerdefinierten Tags und Inline-Dokumentation. Es kann nicht im visuellen Builder bearbeitet werden.',
  fbLegacyFormatHint:
    'Um dieses Format zu ändern, bearbeiten Sie es direkt in den Anpassungseinstellungen.',
  fbOpenCustomizationSettings: 'Anpassungseinstellungen öffnen',
  fbHtmlOutput: 'HTML-Ausgabe',
  fbCopied: 'Kopiert!',
  fbCopy: 'Kopieren',

  // FormatBuilderCanvas.vue
  fbAddElement: 'Element hinzufügen',
  fbHeadings: 'Überschriften',
  fbText: 'Text',
  fbQuotes: 'Zitate',
  fbListsAndTables: 'Listen & Tabellen',
  fbOther: 'Sonstiges',
  fbHeading1: 'Überschrift 1',
  fbHeading2: 'Überschrift 2',
  fbHeading3: 'Überschrift 3',
  fbHeading4: 'Überschrift 4',
  fbParagraph: 'Absatz',
  fbLeadParagraph: 'Einleitungsabsatz',
  fbByline: 'Autorenzeile',
  fbBlockquote: 'Blockzitat',
  fbPullQuote: 'Hervorgehobenes Zitat',
  fbCitation: 'Quellenangabe',
  fbBulletList: 'Aufzählungsliste',
  fbNumberedList: 'Nummerierte Liste',
  fbTable: 'Tabelle',
  fbCalloutBox: 'Hinweisbox',
  fbDivider: 'Trennlinie',
  fbLineBreak: 'Zeilenumbruch',
  fbBlockName: 'Blockname',
  fbOptional: 'Optional',
  fbWords: 'Wörter',
  fbInfo: 'Info',
  fbWarning: 'Warnung',
  fbSuccess: 'Erfolg',
  fbNote: 'Hinweis',
  fbHeaderRow: 'Kopfzeile',
  fbRow: 'Zeile',
  fbCol: 'Spalte',

  // FormatBuilderSidebar.vue
  fbBack: 'Zurück',
  fbCustomization: 'Anpassung',
  fbFormats: 'Formate',
  fbAdmin: 'Admin',
  fbLegacy: 'Legacy',
  fbNoFormatsYet: 'Noch keine Formate',
  fbSaveAllChanges: 'Alle Änderungen speichern',
  fbDeleteFormat: 'Format löschen',
  fbDeleteFormatConfirm:
    'Möchten Sie „{name}" wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.',
  fbCancel: 'Abbrechen',
  fbDelete: 'Löschen',

  // FormatBuilderPreview.vue
  fbDetails: 'Details',
  fbAddElementsToPreview: 'Elemente hinzufügen, um die Vorschau zu sehen',

  // FormatBuilderAIEditor.vue
  fbEditWithAi: 'Mit KI bearbeiten',
  fbEditWithAiDesc:
    'Beschreiben Sie die Änderungen, die Sie an der aktuellen Vorlage vornehmen möchten.',
  fbEditWithAiPlaceholder:
    'z.B. einen Untertitel nach der Überschrift hinzufügen, den Einleitungsabsatz optional machen, eine Tabelle mit 3 Spalten hinzufügen...',
  fbPressToSend: 'Drücke',
  fbToSend: 'zum Senden',
  fbEditing: 'Bearbeiten...',
  fbApplyChanges: 'Änderungen anwenden',

  // FormatBuilderTagPalette.vue
  fbTemplate: 'Vorlage',

  // FormatCreationDialog.vue
  fbAddNewFormat: 'Neues Format hinzufügen',
  fbAddNewFormatDesc:
    'Geben Sie einen Namen ein und beschreiben Sie das Format. Optional können Sie Beispielinhalte bereitstellen, um der KI zu helfen, eine bessere Vorlage zu erstellen.',
  fbFormatName: 'Formatname',
  fbFormatNamePlaceholder: 'z.B. Nachrichtenartikel',
  fbDescription: 'Beschreibung',
  fbDescriptionPlaceholder:
    "Beschreiben Sie die Formatvorlage (z.B. 'Ein Nachrichtenartikel mit Überschrift, Einleitungsabsatz, 3 Textabschnitten und einem Fazit')",
  fbUploadExampleFiles: 'Beispieldateien hochladen',
  fbOptionalLabel: '(optional)',
  fbDropFilesHere: 'Dateien hier ablegen oder klicken zum Durchsuchen',
  fbFileTypes: 'PDF, DOCX, DOC, TXT',
  fbUploadHint:
    'Laden Sie Beispielartikel oder Dokumente hoch, damit die KI die Vorlage auf echten Inhalten basieren kann.',
  fbProcessing: 'Verarbeitung',
  fbDone: 'Fertig',
  fbAddExampleUrls: 'Beispiel-URLs hinzufügen',
  fbAdd: 'Hinzufügen',
  fbUrlHint:
    'Fügen Sie URLs zu Beispielartikeln hinzu, damit die KI deren Struktur analysieren kann.',
  fbScraping: 'Wird abgerufen',
  fbPasteExampleText: 'Beispieltext einfügen',
  fbPasteExampleTextPlaceholder: 'Beispielartikeltext hier einfügen...',
  fbPasteExampleTextHint:
    'Fügen Sie Beispieltext ein, damit die KI die Inhaltsstruktur verstehen kann.',
  fbGenerateAndAdd: 'Generieren & Hinzufügen',

  // useFormatManagement.ts (toasts)
  fbToastFetchFailed: 'Anpassung konnte nicht geladen werden',
  fbToastNameEmpty: 'Formatname darf nicht leer sein',
  fbToastNameExists: 'Ein Format mit diesem Namen existiert bereits',
  fbToastFormatNotFound: 'Format nicht gefunden',
  fbToastCannotDeleteGenerating: 'Ein Format kann nicht gelöscht werden, während es generiert wird',
  fbToastFormatRemoved: 'Format „{name}" entfernt',
  fbToastNoCustomization: 'Keine Anpassung geladen',
  fbToastFormatDeleted: 'Format „{name}" gelöscht',
  fbToastDeleteFailed: 'Format konnte nicht gelöscht werden',
  fbToastHtmlEmpty: 'HTML-Inhalt darf nicht leer sein',
  fbToastInvalidHtml: 'Ungültige HTML-Struktur',
  fbToastTagNotAllowed: 'Tag <{tag}> ist nicht erlaubt',
  fbToastParseFailed: 'HTML konnte nicht verarbeitet werden',
  fbToastFormatSaved: 'Format „{name}" erfolgreich gespeichert',
  fbToastSaveFailed: 'Format konnte nicht gespeichert werden',
  fbToastInvalidFormats: 'Ungültiges HTML in Formaten: {names}',
  fbToastAllSaved: 'Alle Formate erfolgreich gespeichert',
  fbToastSaveAllFailed: 'Formate konnten nicht gespeichert werden'
}
